import { Component, Input, OnInit } from "@angular/core";
import { FormControl } from "@angular/forms";
import { AlertController, ModalController } from "@ionic/angular";
import { OidcSecurityService } from "angular-auth-oidc-client";
import { GutachtenService } from "../../../api/services/gutachten.service";
import { FileViewerComponent } from "../pdf-viewer/file-viewer.component";

@Component({
  selector: "app-gutachten-uebergeben",
  templateUrl: "./gutachten-uebergeben.component.html",
  styleUrls: ["./gutachten-uebergeben.component.scss"],
  standalone: false,
})
export class GutachtenUebergebenComponent implements OnInit {
  @Input({ required: true }) aktId: number;
  @Input({ required: true }) aktTitle: number;
  @Input({ required: true }) gutachtenId: number;
  @Input({ required: true })
  internerBearbeitungsvermerkFormControl: FormControl;
  @Input() showGutachtenVorschau: boolean;
  isSaving: boolean = false;
  submitted: boolean = false;
  loadingPdf: boolean = false;

  constructor(
    private modalController: ModalController,
    private alertController: AlertController,
    private oidcSecurityService: OidcSecurityService,
    private gutachtenService: GutachtenService,
  ) {}

  ngOnInit() {}

  cancelButton() {
    if (this.internerBearbeitungsvermerkFormControl.dirty) {
      this.abbrechenBestaetigenDialogAnzeigen();
    } else {
      this.modalController.dismiss(null, "cancel");
    }
  }

  async submit() {
    this.submitted = true;
    if (this.internerBearbeitungsvermerkFormControl.invalid) {
      this.internerBearbeitungsvermerkFormControl.markAllAsTouched();
      return;
    }

    const alert = await this.alertController.create({
      header: "Gutachten an faircheck übergeben?",
      message:
        "Alle Änderungen werden gespeichert und das Gutachten wird zur Korrektur und Freigabe an faircheck übergeben.",
      buttons: [
        {
          text: "Abbrechen",
          role: "cancel",
          cssClass: "color-primary",
        },
        {
          cssClass: "color-secondary",
          text: "Übergeben",
          handler: async () => {
            this.isSaving = false;
            this.modalController.dismiss(this.internerBearbeitungsvermerkFormControl.value, "confirm");
          },
        },
      ],
    });

    await alert.present();
  }

  async abbrechenBestaetigenDialogAnzeigen() {
    const alert = await this.alertController.create({
      header: "Ungespeicherte Änderungen vorhanden",
      message: "Wollen Sie alle Änderungen verwerfen und das Fenster schließen?",
      buttons: [
        {
          cssClass: "color-primary",
          text: "Abbrechen",
          role: "cancel",
        },
        {
          cssClass: "color-danger",
          text: "Verwerfen",
          handler: () => {
            this.modalController.dismiss(null, "cancel");
          },
        },
      ],
    });
    await alert.present();
  }

  async openPdfViewerModal() {
    this.loadingPdf = true;
    this.gutachtenService
      .gutachtenOdataBerichtPdfCreate({
        token: this.oidcSecurityService.getToken(),
        akt_id: this.aktId,
        gutachten_id: this.gutachtenId,
      })
      .subscribe({
        next: async (pdf) => {
          const modal = await this.modalController.create({
            component: FileViewerComponent,
            cssClass: "modal-fullscreen",
            backdropDismiss: false,
            componentProps: {
              fileSource: pdf,
              fileName: `Gutachten_${this.gutachtenId}.pdf`,
              edit: false,
            },
          });
          this.loadingPdf = false;

          await modal.present();
        },
        error: (err) => {
          this.loadingPdf = false;
        },
      });
  }
}
